import {Injectable} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export type AlertKind = 'info' | 'success' | 'error' | 'neutral' | 'warning';

@Injectable()
export class AlertService {

  constructor(private snackBar: MatSnackBar) {
  }

  show(message: string, kind: AlertKind = 'neutral'): void {
    this.snackBar.open(message, null, {
      duration: 5000,
      panelClass: ['alert-snackbar', `alert-snackbar-${kind}`],
    });
  }
}
